export const contact = {
    title: 'Contact us',
    content_title: 'Burger King Thailand',
    callcenter_title: 'Call center',
    social_title: 'Social media',
    social_burgerKingTh: 'BurgerKingThailand',
    operateHrs9_24: 'Everyday (07.00-02.00)',
    operateHrs24_9: 'Everyday (24.00-09.00)',
    call: 'Call',
    tel1: '1112',
    tel2: '02-0349240',
}
